import { Directive } from '@angular/core';
import { BusinessFleetInsuranceMetadata } from 'src/app/_types/lead.types';
import { getPaymentFrequencyLabel } from 'src/app/enums/payment-frequency.enum';
import { getBooleanLabel } from 'src/app/helpers/utils';

import { BaseMetadataComponent } from '../../base-metadata.component';

@Directive()
export abstract class BusinessFleetMetadataComponentAbstract extends BaseMetadataComponent<BusinessFleetInsuranceMetadata> {
  getBooleanLabel = getBooleanLabel;

  getPaymentFrequencyLabel = getPaymentFrequencyLabel;

  hasGeneralInfo(data?: BusinessFleetInsuranceMetadata): boolean {
    if (!data) return false;
    return [
      data.startDate,
      data.contractDuration,
      data.paymentFrequency,
      data.splitPaymentFee,
      data.hasclaimsLastFiveYears,
      data.claims,
      data.categoryOne,
    ].some((v: any) => v !== null && v !== undefined && v !== '');
  }

  isSectionEmpty(section?: Record<string, any> | null): boolean {
    if (!section) return true;
    const values = Object.values(section);
    if (!values.length) return true;
    return !values.some((v) => v !== null && v !== undefined && v !== '');
  }
}
